import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const Wrapper = styled.div`
  position: absolute;
  right: 15px;
  top: 73px;
  margin: auto;
  width: 36px;
  height: 77px;
  border-radius: 19.5px;
  background-color: #ffffff;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.07);
  @media print {
    display: none !important;
  }
  &.print {
    top: 50%;
    transform: translateY(-50%);
  }
  &:not(.is-embed) {
    ${({ theme }) => theme.onSM(`
      display:none;
      right: 8px;
    `)}
  }
  @media screen and (max-height: 230px) {
    top:15px;
  }
`;

const ZoomBtn = styled.button`
  display: block;
  text-align: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 50%;
  &:active {
    background: #fcfcfc;
  }
`;

const Separator = styled.span`
  width: 18px;
  height: 1px;
  background-color: #ededed;
  display: block;
  margin: 0 auto;
`;

const ZoomIconPlus = styled.span`
  font-size: 1.8rem;
  color: rgba(0, 0, 0, 0.54);
`;

const ZoomIconMinus = styled.span`
  font-size: 1.8rem;
  color: rgba(0, 0, 0, 0.54);
`;

const ZoomControl = (props) => {
  const { urlParams, MapGL } = props;
  const { print, embed } = urlParams || {};
  const zoomIn = () => {
    const nextZoom = MapGL.getZoom() + 1;
    MapGL.zoomTo(nextZoom, null, { type: 'some' });
  };

  const zoomOut = () => {
    const nextZoom = MapGL.getZoom() - 1;
    MapGL.zoomTo(nextZoom, null, { type: 'some' });
  };
  return (
    <Wrapper
      className={
        classNames({
          'print': !!print,
          'is-embed': embed || print,
        })
      }
    >
      <ZoomBtn onClick={zoomIn}>
        <ZoomIconPlus className='icon-add' />
      </ZoomBtn>
      <Separator />
      <ZoomBtn onClick={zoomOut}>
        <ZoomIconMinus className='icon-remove' />
      </ZoomBtn>
    </Wrapper>
  );
};

ZoomControl.propTypes = {
  MapGL: PropTypes.object.isRequired,
  urlParams: PropTypes.object.isRequired,
};

export default ZoomControl;
